<tt-page>
    <tt-list *ngIf="'mobile' | mediaQuery" class="col-xs-12 sp-0" [ttData]="itemsListSalaryTypes"></tt-list>

    <div class="height-full" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
    </div>

    <tt-card class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-button-goto [ttText]="'create_new_salarytype'" (ttClick)="goToFunc('salarytype')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
    </tt-card>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0 height-full">
    <im-list-directive ng-if="vm.model.desktopSize.matches === false" class="col-xs-12 sp-0" list-items="vm.model.itemsListSalaryTypes" badge="" ltype="" design-var="s12t0"></im-list-directive>
    <tt-grid ng-if="vm.model.desktopSize.matches === true && vm.model.gridReady" class="col-xs-12 sp-0 flex-1 height-full" tt-options="vm.grid"></tt-grid>

    <tt-card class="col-xs-12 sp-0" ng-if="vm.model.desktopSize.matches === false">
        <tt-button class="col-xs-12 sp-0" tt-text="create_new_salarytype" tt-click="vm.goToFunc('salarytype')" tt-text-align="left" tt-icon="fa fa-solid fa-plus" tt-icon-pull-right="true"></tt-button>
    </tt-card>
</tt-page>-->
